import { journey } from "@/mocks/site-data";
import Reveal from "@/components/feature/Reveal";

export default function Journey() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-8xl px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
              Jornada da paciente
            </p>
            <h2 className="mt-3 font-heading text-3xl font-medium leading-tight text-foreground-50 md:text-4xl">
              {journey.title}
            </h2>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {journey.steps.map((step, i) => (
            <Reveal key={step.title} delay={i * 100}>
              <div className="relative flex h-full flex-col">
                <span className="font-heading text-5xl font-semibold text-secondary-400 md:text-6xl">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-4 font-heading text-xl font-semibold text-foreground-50">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-400">{step.text}</p>
                {i < journey.steps.length - 1 && (
                  <span className="absolute -right-5 top-6 hidden text-accent-500/60 lg:block">
                    <i className="ri-arrow-right-line text-xl" />
                  </span>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}